<template>
  <div class="tasks-page-container">
    <div v-if="canView">
      <template v-if="list.length">
        <div class="sip-tasks">
          <van-swipe-cell class="sip-task-item" v-for="task in list" :key="task.id">
            <div class="progress">
              <VmProgress v-if="task.status === 'success'" type="circle" :percentage="task.callProgress" :width="80"
                status="success" />
              <VmProgress v-else type="circle" :percentage="task.callProgress" :width="80" />
            </div>
            <div class="info">
              <div class="info-field name-status">
                <div class="name">{{ task.taskName }}</div>
                <div class="status">
                  <van-badge :content="ExecutionStatusMap[task.executionStatus]"
                    :color="ExecutionStatusColor[task.executionStatus]" />
                </div>
              </div>
              <div class="info-field">客户数量：{{ task.namesCount }} 呼损：{{ task.callFailRate }}</div>
              <div class="info-field more-info" v-if="task.sipAccountList.length">
                <span>参与人员：{{ userSipAccounts[task.sipAccountList[0]] }}等{{ task.sipAccountList.length }}人</span>
                <van-button type="info" plain size="mini" @click="onShowTaskAgent(task)">选择</van-button>
              </div>
              <div class="info-field">外呼速率：<van-stepper v-model="task.callSpeed" button-size="22" disable-input
                  @change="(newVal) => onChangeCallSpeed(task, newVal)" :min="8" :max="12"
                  :disabled="!['UNSTART', 'PAUSE', 'COMPLETED'].includes(task.executionStatus)" />
              </div>
              <div class="info-field more-info">
                <span>外呼线路：</span>
                <span>{{ task.validCallLines.join(' ') }}</span>
                <span style="color: #ed4014; text-decoration: line-through;">
                  {{ task.invalidCallLines.join(' ') }}
                </span>
                <van-button type="info" plain size="mini" @click="onShowCallLine(task)">更换</van-button>
              </div>
              <div class="info-field">
                <span>创建时间：{{ task.createTime }}</span>
              </div>
            </div>
            <template #right>
              <van-button square text="开始" type="info" v-if="['INIT', 'COMPLETED'].includes(task.executionStatus)"
                @click="onStartTask(task)" class="action-button" />
              <van-button square text="暂停" type="warning" v-if="['RUNNING'].includes(task.executionStatus)"
                @click="onPauseTask(task)" class="action-button" />
              <van-button square text="继续" type="info" v-if="['PAUSE', 'UNSTART'].includes(task.executionStatus)"
                @click="onContinueTask(task)" class="action-button" />
              <van-button square text="停止" color="#ed6a0c" v-if="['RUNNING', 'PAUSE'].includes(task.executionStatus)"
                @click="onFinishTask(task)" class="action-button" />
              <van-button square text="删除" type="danger"
                v-if="['INIT', 'COMPLETED', 'PAUSE', 'UNSTART', 'STOP', 'ERROR'].includes(task.executionStatus)"
                class="action-button" @click="onDeleteTask(task)" />
            </template>
          </van-swipe-cell>
        </div>
      </template>
      <van-empty v-else image="search" description="无外呼任务，请去创建" />
    </div>
    <van-empty v-else image="network" description="抱歉，您访问的页面不存在" />
    <van-dialog v-model="showCallLine" title="选择外呼线路" show-cancel-button @confirm="onConfirmCallLine">
      <div style="padding: 10px; ">
        <van-row gutter="10">
          <van-checkbox-group v-model="selectedLines" direction="horizontal">
            <van-col span="12" v-for="callLine in taskCallLines" :key="callLine" style="padding: 3px 0;">
              <van-checkbox :name="callLine">{{ callLine }}</van-checkbox>
            </van-col>
          </van-checkbox-group>
        </van-row>
      </div>
    </van-dialog>
    <van-popup v-model="showTaskAgent" position="bottom" closeable :style="{ height: '60%' }">
      <van-tree-select height="calc(100% - 60px)" :items="userTree" :active-id.sync="activeUserIds"
        :main-active-index.sync="activeL1UserIndex" />
      <div style="height: 60px; display: flex; justify-content: center; align-items: center; padding: 8px;">
        <van-button type="danger" block @click="onConfirmTaskAgent" :loading="loading">提交</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Dialog } from 'vant'
import Progress from 'vue-multiple-progress'
import { hasOneOf } from '@/util'
import { intersection } from 'lodash'
import { getUserList, getCallLineConfig, fetchRoleCodeList } from '@/services/UserService'
import {
  getTaskList,
  startTask,
  pauseTask,
  continueTask,
  finishTask,
  updateTask,
  deleteTask,
  updateCallSpeed
} from '@/services/TaskService'

const ExecutionStatusMap = {
  INIT: '初始化',
  UNSTART: '未开始',
  IMPORTING: '导入中',
  STARTING: '启动中',
  RUNNING: '进行中',
  PAUSING: '暂停中',
  PAUSE: '已暂停',
  STOPPING: '停止中',
  STOP: '已停止',
  COMPLETED: '已完成',
  ERROR: '已失败'
}

const ExecutionStatusColor = {
  INIT: '#bbb',
  UNSTART: '#bbb',
  IMPORTING: '#2d8cf0',
  STARTING: '#2d8cf0',
  RUNNING: '#2d8cf0',
  PAUSING: '#f90',
  PAUSE: '#f90',
  STOPPING: '#f90',
  STOP: '#f90',
  COMPLETED: '#19be6b',
  ERROR: '#ed4014'
}

export default {
  components: {
    VmProgress: Progress
  },
  data() {
    return {
      ExecutionStatusMap,
      ExecutionStatusColor,
      openId: localStorage.getItem('openId'),
      roleCodeList: [],
      loading: false,
      list: [],
      users: [],
      userTree: [],
      userSipAccounts: {},
      activeUserIds: [],
      activeL1UserIndex: 0,
      currentTask: {},
      showTaskAgent: false,
      taskCallLines: [],
      showCallLine: false,
      selectedLines: []
    }
  },
  computed: {
    canView() {
      return this.roleCodeList && this.roleCodeList.length &&
        hasOneOf(this.roleCodeList, ['T', 'M', 'L1'])
    }
  },
  async mounted() {
    this.$toast.loading({
      duration: 0,
      message: '数据加载中...',
      forbidClick: true
    })
    await this.onInitRoleCodeList()
    await this.onInitCallLine()
    await this.onInitUsers()
    await this.onInitData()
    this.onGenerateCUserTree()
    this.$toast.clear()
  },
  beforeUnmount() {
    clearInterval(this.timer)
  },
  methods: {
    async onInitRoleCodeList() {
      const response = await fetchRoleCodeList({ openId: this.openId })
      const roleCodeList = response.data || []
      this.roleCodeList = roleCodeList
    },
    async onInitCallLine() {
      try {
        const response = await getCallLineConfig({
          openId: this.openId
        })
        this.taskCallLines = response.data.callLineConfig.taskCallLine
      } catch (e) { }
    },
    async onInitUsers() {
      const response = await getUserList({
        openId: this.openId,
        pageNum: 1,
        pageSize: 2000
      })
      this.users = ((response.data || {}).records || []).filter(i => i.status === 0 && i.number)

      const userSipAccounts = {}
      this.users.forEach(user => {
        userSipAccounts[user.sipAccount] = user.name
      })
      this.userSipAccounts = userSipAccounts
    },
    async onInitData() {
      const response = await getTaskList({
        openId: this.openId,
        pageNum: 1,
        pageSize: 500
      })
      const list = ((response.data || {}).records || []).map(item => {
        const { executionStatus, seatAnswerRate, callLineInfo } = item
        const isShowCallFailRate = ['INIT', 'IMPORTING', 'UNSTART', 'ERROR'].includes(executionStatus)
        const percent = Number(item.callProgress * 100)
        const { validKeys, invalidKeys } = this.onValidCallLine(item)
        return {
          ...item,
          callProgress: Number(item.callProgress * 100).toFixed(2),
          callFailRate: isShowCallFailRate ? '--' : `${((1 - seatAnswerRate) * 100).toFixed(2)}%`,
          callLines: Reflect.ownKeys(callLineInfo),
          validCallLines: validKeys,
          invalidCallLines: invalidKeys,
          status: percent === 100 ? 'success' : 'default'
        }
      })
      this.list = list
    },
    onGenerateCUserTree() {
      const l1Users = this.users.filter(user => hasOneOf(user.roleCodeList, 'L1')).map(user => ({
        id: user.userId,
        text: user.name,
        children: []
      }))
      for (let i = 0; i < l1Users.length; i++) {
        this.users.forEach(user => {
          if (user.supervisorIds === l1Users[i].id) {
            if (!user.children) {
              user.children = []
            }
            l1Users[i].children.push({
              id: user.userId,
              text: user.name
            })
          }
        })
      }
      this.userTree = l1Users
    },
    onFindRunningTaskAndUser() {
      const map = {}
      this.list.forEach(item => {
        if (['RUNNING'].includes(item.executionStatus)) {
          map[item.taskName] = item.sipAccountList.map(sipAccount => {
            const user = this.users.find(user => user.sipAccount === sipAccount)
            return (user || {}).name
          })
        }
      })
      return map
    },
    onValidConflict(record) {
      const sipAccountNames = record.sipAccountList.map(sipAccount => {
        const user = this.users.find(user => user.sipAccount === sipAccount)
        return (user || {}).name
      })
      const result = this.onFindRunningTaskAndUser()
      const conflictedResult = []
      Object.keys(result).forEach(key => {
        const bothHas = intersection(sipAccountNames, result[key])
        if (bothHas && bothHas.length) {
          conflictedResult.push({
            key,
            value: intersection(sipAccountNames, result[key]).join('，')
          })
        }
      })
      if (conflictedResult.length) {
        Dialog.alert({
          title: '坐席冲突',
          message: conflictedResult.map(
            item =>
              `${record.taskName}与进行中的任务${item.key}中的坐席${item.value}冲突，无法开始，请等待${item.key}完成或将其暂停/停止。`).join('\n\r')
        })
      }
      return !!conflictedResult.length
    },
    onValidCallLine(record, type) {
      const { callLineInfo } = record
      const validKeys = []
      const invalidKeys = []
      Reflect.ownKeys(callLineInfo).forEach(key => {
        if (this.taskCallLines.includes(key)) {
          validKeys.push(key)
        } else if (key !== '__ob__') {
          invalidKeys.push(key)
        }
      })
      if (type) {
        if (invalidKeys.length) {
          Dialog.alert({
            title: '线路失效',
            message: `${record.taskName}中外呼线路${invalidKeys.join(',')}已失效，无法开始。请重新编辑后再操作。`
          })
        }
        return !!invalidKeys.length
      }
      return {
        validKeys,
        invalidKeys
      }
    },
    onStartTask(task) {
      const validResult = this.onValidConflict(task)
      if (validResult) {
        return
      }
      const validCallLineResult = this.onValidCallLine(task, 'popup')
      if (validCallLineResult) {
        return
      }

      Dialog.confirm({
        title: '开始任务',
        message: `您确定开始${task.taskName}吗？`
      }).then(async () => {
        this.$toast.loading({
          duration: 0,
          message: '数据加载中...',
          forbidClick: true
        })
        const response = await startTask({
          openId: this.openId,
          id: task.id
        })
        if (response.code === 1000) {
          this.$toast.clear()
          this.$toast.success('开始成功')
          this.$set(task, 'executionStatus', 'IMPORTING')
        } else {
          this.$toast.fail(response.message)
        }
      }).catch(() => { })
    },
    onPauseTask(task) {
      Dialog.confirm({
        title: '暂停任务',
        message: `您确定暂停${task.taskName}吗？`
      }).then(async () => {
        this.$toast.loading({
          duration: 0,
          message: '数据加载中...',
          forbidClick: true
        })
        const response = await pauseTask({
          openId: this.openId,
          id: task.id
        })
        if (response.code === 1000) {
          this.$toast.clear()
          this.$toast.success('暂停成功')
          this.$set(task, 'executionStatus', 'PAUSING')
        } else {
          this.$toast.fail(response.message)
        }
      }).catch(() => { })
    },
    onContinueTask(task) {
      const validResult = this.onValidConflict(task)
      if (validResult) {
        return
      }
      const validCallLineResult = this.onValidCallLine(task, 'popup')
      if (validCallLineResult) {
        return
      }

      Dialog.confirm({
        title: '继续任务',
        message: `您确定继续${task.taskName}吗？`
      }).then(async () => {
        this.$toast.loading({
          duration: 0,
          message: '数据加载中...',
          forbidClick: true
        })
        const response = await continueTask({
          openId: this.openId,
          id: task.id
        })
        if (response.code === 1000) {
          this.$toast.clear()
          this.$toast.success('继续成功')
          this.$set(task, 'executionStatus', 'STARTING')
        } else {
          this.$toast.fail(response.message)
        }
      }).catch(() => { })
    },
    onFinishTask(task) {
      Dialog.confirm({
        title: '停止任务',
        message: `您确定停止${task.taskName}吗？`
      }).then(async () => {
        this.$toast.loading({
          duration: 0,
          message: '数据加载中...',
          forbidClick: true
        })
        const response = await finishTask({
          openId: this.openId,
          id: task.id
        })
        if (response.code === 1000) {
          this.$toast.clear()
          this.$toast.success('停止成功')
          this.$set(task, 'executionStatus', 'STOPPING')
        } else {
          this.$toast.fail(response.message)
        }
      }).catch(() => { })
    },
    onDeleteTask(task) {
      Dialog.confirm({
        title: '删除任务',
        message: `您确定删除${task.taskName}吗？`
      }).then(async () => {
        this.$toast.loading({
          duration: 0,
          message: '数据加载中...',
          forbidClick: true
        })
        const response = await deleteTask({
          openId: this.openId,
          id: task.id
        })
        if (response.code === 1000) {
          this.$toast.clear()
          this.$toast.success('删除成功')
          const index = this.list.findIndex(item => item.id === task.id)
          this.list.splice(index, 1)
        } else {
          this.$toast.fail(response.message)
        }
      }).catch(() => { })
    },
    async onChangeCallSpeed(task, newVal) {
      this.$toast.loading({
        duration: 0,
        message: '数据加载中...',
        forbidClick: true
      })
      await updateCallSpeed({
        openId: this.openId,
        id: task.id,
        callSpeed: newVal
      })
      this.$toast.clear()
    },
    onShowTaskAgent(task) {
      this.currentTask = task
      this.activeL1UserIndex = this.userTree.findIndex(user => user.id === task.createUserId)
      this.activeUserIds = task.sipAccountList
      this.showTaskAgent = true
    },
    async onConfirmTaskAgent() {
      const params = this.generateParams('taskAgent', this.activeUserIds)
      this.loading = true
      const response = await updateTask(params)
      if (response.code === 1000) {
        this.loading = false
        this.showTaskAgent = false
        this.$toast.success('选择成功')
        this.$set(this.currentTask, 'sipAccountInfo', params.sipAccountInfo)
        this.$set(this.currentTask, 'sipAccountList', params.sipAccountInfo.map(i => i.sipAccount))
      } else {
        this.$toast.fail(response.message)
      }
    },
    onShowCallLine(task) {
      this.selectedLines = task.callLines
      this.currentTask = task
      this.showCallLine = true
    },
    async onConfirmCallLine() {
      const params = this.generateParams('callLine', this.selectedLines)
      this.$toast.loading({
        duration: 0,
        message: '数据加载中...',
        forbidClick: true
      })
      const response = await updateTask(params)
      if (response.code === 1000) {
        this.$toast.clear()
        this.$toast.success('更换成功')
        this.$set(this.currentTask, 'callLines', Reflect.ownKeys(params.callLineInfo))
        const { validKeys, invalidKeys } = this.onValidCallLine({
          callLineInfo: params.callLineInfo
        })
        this.$set(this.currentTask, 'validCallLines', validKeys)
        this.$set(this.currentTask, 'invalidCallLines', invalidKeys)
      } else {
        this.$toast.fail(response.message)
      }
    },
    generateParams(type, data) {
      const params = {
        openId: this.openId,
        id: this.currentTask.id,
        taskName: this.currentTask.taskName,
        strategyInfo: this.currentTask.strategyInfo,
        callSpeed: this.currentTask.callSpeed,
        callLineInfo: {},
        sipAccountInfo: [],
        batchCodeList: this.currentTask.batchCodeList,
        executionMode: 'NOW',
        requestSource: 'spark',
        priority: 'user',
        maxAttempts: 2
      }
      if (type === 'callLine') {
        params.sipAccountInfo = this.currentTask.sipAccountInfo
        const ratio = (100 / data.length).toFixed(0)
        const lastRatio = 100 - ratio * (data.length - 1)
        data.forEach((line, index) => {
          if (index === data.length - 1) {
            params.callLineInfo[line] = `${lastRatio}`
          } else {
            params.callLineInfo[line] = `${ratio}`
          }
        })
      }
      if (type === 'taskAgent') {
        params.callLineInfo = this.currentTask.callLineInfo
        const userNumbers = {}
        this.users.forEach(user => {
          userNumbers[user.sipAccount] = user.number
        })
        data.forEach((sipAccount) => {
          params.sipAccountInfo.push({
            taskId: '',
            sipAccount: sipAccount,
            number: userNumbers[sipAccount]
          })
        })
      }
      return params
    }
  }
}
</script>
<style lang="stylus">
.tasks-page-container {
  height: calc(100vh - 50px);
  background-color: #fff;
  overflow: auto;

  .sip-tasks {
    padding 5px
    .sip-task-item {
      background #f6f6f6
      border-radius 5px
      margin-bottom 5px
      .van-swipe-cell__wrapper {
        display flex
        padding 10px 0
        margin-right -1px
        .action-button {
          height 100%
        }
        .progress {
          padding 5px 20px 5px 5px
        }
        .info {
          flex: 1
          .info-field {
            height 20px
            font-size: 13px;
            color: #797d82;
            display flex
            .call-line {
              color #1989fa
            }
            &.more-info {
              .van-button--mini {
                height 18px
                margin-left 5px
              }
            }
          }
          .name-status {
            display flex
            align-items center
            .name {
              display inline-block
              max-width 130px
              color: #191a1b;
              font-size: 16px;
              height: 22px;
              font-weight 600
              line-height: 22px;
              margin-right: 5px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .status {
              display flex
              .van-badge {
                font-size 10px
                padding 3px 5px
              }
            }
          }
        }
      }
    }
  }
  .van-empty {
    height 100vh
  }
  .no-auth {
    height 100vh
    display flex
    flex-direction column
    align-items center
    padding-top 100px
    img {
      width 80%
    }
    p {
      margin-top: 16px;
      color: #808695;
      font-size: 20px;
      line-height: 28px;
    }
  }
}

</style>
